import { render, staticRenderFns } from "./moduleIndex.vue?vue&type=template&id=0b33180b&scoped=true"
import script from "./moduleIndex.vue?vue&type=script&lang=js"
export * from "./moduleIndex.vue?vue&type=script&lang=js"
import style0 from "./moduleIndex.vue?vue&type=style&index=0&id=0b33180b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b33180b",
  null
  
)

export default component.exports